/** The kinds of change a release can list, in the order the page shows them. */
export const CHANGE_KINDS = ['new', 'improved', 'fixed']

/** How each kind looks: its icon, its dot's colours, and its label colour. */
export const KINDS = {
  all: { icon: 'menu', dot: 'bg-line text-body', text: 'text-body' },
  new: { icon: 'plus', dot: 'bg-brand-tint text-brand', text: 'text-brand' },
  improved: {
    icon: 'arrowUp',
    dot: 'bg-[#e7f6ec] text-[#1f9d55]',
    text: 'text-[#1f9d55]',
  },
  fixed: {
    icon: 'check',
    dot: 'bg-[#fdecea] text-[#c5221f]',
    text: 'text-[#c5221f]',
  },
}

/** A release's anchor on the page, from its version: "v2.4" → "v2-4". */
export const releaseId = (version) => version.replace(/[^\w-]/g, '-')
